import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  transaksiKeluarTable,
  extraTransaksiKeluarRow,
} from "./transaksiKeluarTable";
import { transaksiKeluarDetailTable } from "./transaksiKeluarDetailTable";
import { transaksiKeluarFilter } from "./transaksiKeluarFilterData";

// API
import {
  getDataTransKeluar,
  getFilteredTransaksiKeluar,
  deleteTransaksiKeluar,
  insertNewTransaksiKeluar,
  updateTransaksiKeluar,
  getNomorTransaksiKeluar,
  importCSVTransaksiKeluar,
  exportSpesifikTransaksiKeluar,
} from "./api/transaksiKeluarAPI";
import { getDropdownTahunAnggaranPengeluaran } from "views/admin/masterData/anggaranPengeluaran/api/anggaranPengeluaranAPI";

// Component
import CardTableNoAdd from "components/Cards/CardTableNoAdd";
import ConfirmModal from "components/Modal/ConfirmModal";
import FormCustom from "components/Forms/FormCustom";

import toast, { Toaster } from "react-hot-toast";
import {
  transaksiKeluarFormData,
  transaksiKeluarPindahAnggaranFormData,
} from "./transaksiKeluarFormData";
import jsPDF from "jspdf";
import ShowDetailModal from "components/Modal/ShowDetailModal";
import UploadFileModal from "components/Modal/UploadFileModal";
import { getDropdownPelanggan } from "views/admin/masterData/pelanggan/api/pelangganAPI";
import { getDropdownKodeAkunOnlyKas } from "views/admin/masterData/kodeAkun/api/kodeAkunAPI";
import { getDropdownUnitUsaha } from "views/admin/masterData/unitUsaha/api/unitUsahaAPI";
import UploadMultipleFileModal from "components/Modal/UploadMultipleFileModal";
import ExcelExport from "components/Exports/ExcelExport";
import { getDropdownAnggaranPengeluaran } from "views/admin/masterData/anggaranPengeluaran/api/anggaranPengeluaranAPI";

export default function TransaksiKeluar() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  // Type Search
  const [typeSearch, setTypeSearch] = useState("");

  const [currentData, setCurrentData] = useState([]);
  const [typeSearchDetail, setTypeSearchDetail] = useState("");

  // Select-Option Data
  const [dropdownTahunAnggaran, setDropdownTahunAnggaran] = useState([]);
  const [dropdownPelanggan, setDropdownPelanggan] = useState([]);
  const [dropdownOnlyKas, setDropdownOnlyKas] = useState([]);
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);
  const [dropdownAnggaranPengeluaran, setDropdownAnggaranPengeluaran] =
    useState([]);

  const [noTransKeluar, setNoTransKeluar] = useState("K-NNNN-NNN");

  // Filter Data
  const [filterData, setFilterData] = useState(null);

  // File Data Arr
  const [filterDataArr, setFilterDataArr] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  // State for Upload Bukti Transaksi Masuk
  const [uploadedFile, setUploadedFile] = useState(null);

  // State for Upload CSV
  const [uploadedCSVFile, setUploadedCSVFile] = useState(null);

  // State for Tabke Detail Transaksi Keluar
  const [showDetailTransaksi, setShowDetailTransaksi] = useState(false);
  const [detailTransaksi, setDetailTransaksi] = useState(false);

  const [result, setResult] = useState(null);
  const [deleteResult, setDeleteResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [deletePopUp, setDeletePopUp] = useState({ show: false, id: null });
  const [showDetailPopUp, setShowDetailPopUp] = useState({
    show: false,
    id: null,
    data: null,
  });

  const [showUploadBuktiTransaksiPopUp, setShowUploadBuktiTransaksiPopUp] =
    useState([
      {
        show: false,
        id: null,
        data: null,
      },
    ]);

  const [showUploadCSVPopUp, setShowUploadCSVPopUp] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);

  const [showPindahAnggaran, setShowPindahAnggaran] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);

  // State for Input New Transaksi Keluar
  const [addForm, setAddForm] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataArr, setFormDataArr] = useState([]);

  // State for Pindah Anggaran
  const [formDataPindahAnggaran, setFormDataPindahAnggaran] = useState(null);
  const [formDataArrPindahAnggaran, setFormDataArrPindahAnggaran] = useState(
    []
  );

  // Extra Row Params
  const [totalTarget, setTotalTarget] = useState(0);
  const [totalRealisasi, setTotalRealisasi] = useState(0);

  const [dataExport, setDataExport] = useState([]);

  // Component is Active?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  useEffect(() => {
    exportSpesifikTransaksiKeluar()
      .then((res) => {
        console.log(res.data);
        setDataExport(res.data.data);
      })
      .catch((err) => {
        setErrors(err);
      });
  }, []);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTransKeluar()
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }

    return () => {
      // setFormData(null);
    };
  }, [active]);

  // Select-Option Data
  // Load Dropdown Tahun Anggaran Pengeluaran
  useEffect(() => {
    setIsLoading(true);

    getDropdownTahunAnggaranPengeluaran()
      .then((response) => {
        setDropdownTahunAnggaran(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownTahunAnggaran([]);
    };
  }, [active]);

  // Load Dropdown Anggaran Pemasukan
  useEffect(() => {
    setIsLoading(true);

    getDropdownAnggaranPengeluaran()
      .then((response) => {
        setDropdownAnggaranPengeluaran(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAnggaranPengeluaran([]);
    };
  }, [active]);

  // Load Dropdown Pelanggan
  useEffect(() => {
    setIsLoading(true);

    getDropdownPelanggan()
      .then((response) => {
        setDropdownPelanggan(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownPelanggan([]);
    };
  }, [active]);

  // Load Dropdown Kode Akun Only Kas
  useEffect(() => {
    setIsLoading(true);

    getDropdownKodeAkunOnlyKas()
      .then((response) => setDropdownOnlyKas(response.data.data))
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, [active]);

  // Load Dropdown Unit Usaha
  useEffect(() => {
    setIsLoading(true);

    getDropdownUnitUsaha()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, [active]);

  // Load Nomor Transaksi Keluar
  useEffect(() => {
    setIsLoading(true);

    getNomorTransaksiKeluar()
      .then((response) => {
        setNoTransKeluar(response.data.data.nomor_transaksi_keluar);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setNoTransKeluar("K-NNNN-NNN");
    };
  }, [active]);

  // Load Filter Data Arr
  useEffect(() => {
    setFilterDataArr(
      transaksiKeluarFilter(dropdownTahunAnggaran, dropdownUnitUsaha)
    );

    return () => {
      setFilterDataArr([]);
    };
  }, [dropdownTahunAnggaran, dropdownUnitUsaha]);

  const setDataFilter = (key, value) => {
    return setFilterData({ ...filterData, [key]: value });
  };

  // Handle when user click button filter data
  const handleFilter = () => {
    if (filterData !== null) {
      getFilteredTransaksiKeluar(filterData)
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    }
  };

  // Handle when user click button reset filter data
  const handleResetFilter = () => {
    setFilterData(null);
    getDataTransKeluar()
      .then((response) => {
        setDataTable(response.data.data);
        setTotalRealisasi(response.data.total_realisasi);
        setTotalTarget(response.data.total_target);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));
    setPageNumber(0);
  };

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  const handleSearchDetail = (e) => {
    setTypeSearchDetail(e.target.value);
  };

  // Handle when searching changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTransKeluar(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTransKeluar()
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle when searching detail changes
  useEffect(() => {
    const getDataSearchDetailResult = () => {
      const detailDataTransaksiKeluar = currentData.detail_transaksi_keluar;

      const filterDataDetailTransaksiKeluar = detailDataTransaksiKeluar.filter(
        (obj) => {
          return (
            (obj.nomor_transaksi_keluar &&
              obj.nomor_transaksi_keluar
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.keterangan_transaksi_keluar &&
              obj.keterangan_transaksi_keluar
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.nama_pelanggan &&
              obj.nama_pelanggan
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.nama_akun_via_bayar_keluar &&
              obj.nama_akun_via_bayar_keluar
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.tanggal_transaksi_keluar &&
              obj.tanggal_transaksi_keluar
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase()))
          );
        }
      );

      Array.isArray(filterDataDetailTransaksiKeluar) &&
        filterDataDetailTransaksiKeluar.sort((a, b) => {
          let da = new Date(a.tanggal_transaksi_masuk);
          let db = new Date(b.tanggal_transaksi_masuk);
          return db - da;
        });

      setDetailTransaksi(filterDataDetailTransaksiKeluar);
    };

    const getDataDetail = () => {
      const filterDataDetailTransaksiKeluar =
        currentData.detail_transaksi_keluar;

      Array.isArray(filterDataDetailTransaksiKeluar) &&
        filterDataDetailTransaksiKeluar.sort((a, b) => {
          let da = new Date(a.tanggal_transaksi_masuk);
          let db = new Date(b.tanggal_transaksi_masuk);
          return db - da;
        });

      setDetailTransaksi(filterDataDetailTransaksiKeluar);
    };

    let timer = setTimeout(() => {
      if (typeSearchDetail) {
        getDataSearchDetailResult();
      } else {
        getDataDetail();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [currentData, typeSearchDetail]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Handle when User want to see detail transaksi Keluar
  const handleGetDetail = (rowData) => {
    // Lihat Detail Transaksi
    setActive(false);
    setShowDetailTransaksi(true);
    setPageNumber(0);

    setCurrentData(rowData);
    const detailDataTransaksiKeluar = rowData.detail_transaksi_keluar;

    detailDataTransaksiKeluar.sort((a, b) => {
      let da = new Date(a.tanggal_transaksi_keluar);
      let db = new Date(b.tanggal_transaksi_keluar);
      return db - da;
    });

    // Tambahkan Data Detail Transaksi
    setDetailTransaksi(detailDataTransaksiKeluar);
  };

  // Handle when user click cancel button in detail transaksi keluar
  const handleCancelButton = () => {
    setShowDetailTransaksi(false);
    // setPageNumberDetail(0);
    setAddForm(false);
    handleClosePindahAnggaran();
  };

  // Handle when User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_keluar,
    });
  };

  // Handle when user confirm to delete data
  const handleDeleteTrue = () => {
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiKeluar(deletePopUp.id)
        .then((response) => {
          setDetailTransaksi(
            detailTransaksi.filter((dT) => {
              return dT.id_transaksi_keluar !== deletePopUp.id;
            })
          );
          setDeleteResult(response);
        })
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle when user deny to confirm delete data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle when User click show detail button
  function handleShowDetail(rowData) {
    setShowDetailPopUp({
      show: true,
      id: rowData.id_transaksi_keluar,
      data: rowData,
    });
  }

  // Handle when user deny to confirm delete data
  const handleCloseShowDetail = () => {
    setShowDetailPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when User click Upload Bukti Button
  const handleUploadBuktiTransaksi = (rowData) => {
    setShowUploadBuktiTransaksiPopUp({
      show: true,
      id: rowData.id_transaksi_keluar,
      data: null,
    });
  };

  const handleCloseUploadBuktiTransaksi = () => {
    setShowUploadBuktiTransaksiPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when user click import CSV
  const handleUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: true,
      id: null,
      data: null,
    });
  };

  // Handle when User click close import CSV
  const handleCloseUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when user click pindah anggaran
  const handlePindahAnggaran = (rowData) => {
    setShowPindahAnggaran({
      show: true,
      id: rowData.id_transaksi_keluar,
      data: rowData,
    });
  };

  // Handle when user click close pindah anggaran
  const handleClosePindahAnggaran = () => {
    setShowPindahAnggaran({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle End Submit Process
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  // Check if request failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  });

  // Check if request success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setShowDetailTransaksi(false);
        setFormData(null);
        setAddForm(false);
        setActive(true);
        history.push("/transaction/transaksiKeluar");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);

      toast.dismiss();
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Check if Delete Request Success
  useEffect(() => {
    if (deleteResult !== null) {
      if (deleteResult.data.success === true) {
        toast.success(deleteResult.data.message);
        setActive(true);
        setShowDetailTransaksi(true);
      } else {
        let numericArray = [];
        for (let err in deleteResult.data.errors) {
          numericArray.push(deleteResult.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setDeleteResult(null);
    }
  }, [deleteResult]);

  // Clear Form Data when first time load component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(
      transaksiKeluarFormData(dropdownPelanggan, noTransKeluar, dropdownOnlyKas)
    );

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownPelanggan, noTransKeluar, dropdownOnlyKas]);

  // Load Form Data Arr Pindah Anggaran
  useEffect(() => {
    setFormDataArrPindahAnggaran(
      transaksiKeluarPindahAnggaranFormData(dropdownAnggaranPengeluaran)
    );

    return () => {
      setFormDataArrPindahAnggaran([]);
    };
  }, [dropdownAnggaranPengeluaran]);

  // Handle when user click add button
  function handleInsert(rowData) {
    setActive(false);
    setFormData({ id_anggaran_pengeluaran: rowData.id_anggaran_pengeluaran });
    setAddForm(true);
  }

  // Handle when user submit new data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const data = new FormData();

    if (formData !== null) {
      Object.keys(formData).forEach(
        (key) =>
          key !== "bukti_transaksi_keluar" && data.append(key, formData[key])
      );

      if (formData?.bukti_transaksi_keluar) {
        if (formData?.bukti_transaksi_keluar.length > 0) {
          for (const bukti of formData.bukti_transaksi_keluar) {
            data.append("bukti_transaksi_keluar[]", bukti);
          }
        }
      }
    }

    insertNewTransaksiKeluar(data)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Edit (Upload Bukti Transaksi Keluar)
  const handleSubmitUploadBuktiTransaksi = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    if (uploadedFile !== null) {
      if (uploadedFile["bukti_transaksi_keluar"]) {
        if (uploadedFile["bukti_transaksi_keluar"].length > 0) {
          for (const bukti of uploadedFile["bukti_transaksi_keluar"]) {
            formData.append("bukti_transaksi_keluar[]", bukti);
          }
        }
      }
    }

    updateTransaksiKeluar(showUploadBuktiTransaksiPopUp.id, formData)
      .then((response) => {
        setResult(response);
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Submit Import CSV
  const handleSubmitUploadCSV = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    if (uploadedCSVFile !== null) {
      formData.append(
        "csv_transaksi_keluar",
        uploadedCSVFile["csv_transaksi_keluar"]
      );
    }

    importCSVTransaksiKeluar(formData)
      .then((response) => {
        handleCloseUploadCSV();
        setActive(false);
        setResult(response);
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Submit Pindah Anggaran
  const handleSubmitPindahAnggaran = (e) => {
    e.preventDefault();

    const formData = new FormData();

    if (!formDataPindahAnggaran?.id_anggaran_pengeluaran) {
      toast.error("Silahkan Pilih Anggaran Terlebih Dahulu");
      return;
    }

    setIsLoading(true);

    formData.append(
      "id_anggaran_pengeluaran",
      formDataPindahAnggaran.id_anggaran_pengeluaran
    );

    handleClosePindahAnggaran();

    updateTransaksiKeluar(showPindahAnggaran.id, formData)
      .then((response) => {
        if (response !== null) {
          if (response.data.success === true) {
            let updatedDetailTransaksi = [];

            if (
              currentData.id_anggaran_pengeluaran !==
              formDataPindahAnggaran.id_anggaran_pengeluaran
            ) {
              updatedDetailTransaksi = detailTransaksi.filter((obj) => {
                return obj.id_transaksi_keluar !== showPindahAnggaran.id;
              });
            } else {
              updatedDetailTransaksi = detailTransaksi;
            }

            const updatedCurrentData = currentData;

            updatedCurrentData.detail_transaksi_keluar = updatedDetailTransaksi;

            setDetailTransaksi(updatedDetailTransaksi);
            setCurrentData(updatedCurrentData);
            toast.success(response.data.message);
            setActive(true);
            setFormData(null);
            setAddForm(false);
            setShowDetailTransaksi(true);
          } else {
            let numericArray = [];
            for (let err in response.data.errors) {
              numericArray.push(response.data.errors[err]);
            }

            if (numericArray.length > 0) {
              toast.error(numericArray[0]);
            }
          }

          toast.dismiss();
        }
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Cetak Bukti Pengeluaran
  const handleCetakBuktiPengeluaran = (rowData) => {
    const doc = new jsPDF();

    doc.setFontSize(12);
    doc.text("Jl. Subang Bandung KM 12 RT 24", 12, 20);
    doc.text("RW 4 Ds. Tambak Mekar Kec.", 12, 30);
    doc.text("Jalancagak.", 12, 40);

    doc.text(`No: ${rowData.nomor_transaksi_keluar}`, 160, 20);
    doc.setFontSize(16);
    doc.text("Bukti Kas Keluar", 105, 60, null, null, "center");
    doc.setFontSize(14);
    doc.text("Dikeluarkan anggaran untuk", 40, 70);
    doc.text(`: ${rowData.nama_anggaran_pengeluaran}`, 120, 70);
    doc.text("Jumlah", 40, 80);
    doc.text(`: ${rowData.jumlah_transaksi_keluar}`, 120, 80);
    doc.text("Keterangan Transaksi :", 12, 93);
    doc.setFontSize(12);
    doc.text(`${rowData.keterangan_transaksi_keluar}`, 12, 103);
    doc.setFontSize(12);
    doc.text(`Subang, ${rowData.created_at}`, 200, 120, null, null, "right");
    doc.text("Yang Mengeluarkan", 200, 130, null, null, "right");
    doc.text(`${rowData.created_by}`, 200, 160, null, null, "right");

    doc.save(`bukti-kas-keluar-${rowData.nomor_transaksi_keluar}.pdf`);
  };

  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  const setFile = (key, value) => {
    return setUploadedFile({ [key]: value });
  };

  const setCSVFile = (key, value) => {
    return setUploadedCSVFile({ [key]: value });
  };

  const setDataPindahAnggaran = (key, value) => {
    return setFormDataPindahAnggaran({
      ...formDataPindahAnggaran,
      [key]: value,
    });
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
              // getData = {getData}
            />
          </div>
        </div>
      </div>
    );

  if (showDetailTransaksi === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            {deletePopUp.show && (
              <div>
                <ConfirmModal
                  handleIfTrue={(e) => handleDeleteTrue()}
                  handleIfFalse={(e) => handleDeleteFalse()}
                />
              </div>
            )}
            {showDetailPopUp.show && (
              <div>
                <ShowDetailModal
                  handleClose={(e) => handleCloseShowDetail()}
                  detailData={showDetailPopUp.data}
                />
              </div>
            )}
            {showUploadBuktiTransaksiPopUp.show && (
              <div>
                <UploadMultipleFileModal
                  handleSubmit={handleSubmitUploadBuktiTransaksi}
                  handleClose={(e) => handleCloseUploadBuktiTransaksi()}
                  setFile={setFile}
                  name="bukti_transaksi_keluar"
                  fileExtensions="jpg, png, jpeg"
                />
              </div>
            )}
            {showPindahAnggaran.show && (
              <div>
                <FormCustom
                  title={`Pindah Anggaran (Nomor Transaksi: ${showPindahAnggaran.data.nomor_transaksi_keluar})`}
                  formDataArr={formDataArrPindahAnggaran}
                  handleSubmit={handleSubmitPindahAnggaran}
                  handleCancelButton={handleClosePindahAnggaran}
                  setData={setDataPindahAnggaran}
                  editFormValue={null}
                />
              </div>
            )}
            <Toaster />
            <CardTableNoAdd
              tableTitle="Tabel Detail Transaksi Pengeluaran"
              cols={transaksiKeluarDetailTable(
                handleUploadBuktiTransaksi,
                handleCetakBuktiPengeluaran,
                handlePindahAnggaran,
                handleDelete,
                handleShowDetail
              )}
              handleSearch={handleSearchDetail}
              data={detailTransaksi}
              handleCancelButton={handleCancelButton}
              pageNumber={pageNumber}
              changePage={changePage}
              exportCSVButton={true}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {showUploadCSVPopUp.show && (
            <div>
              <UploadFileModal
                handleSubmit={handleSubmitUploadCSV}
                handleClose={(e) => handleCloseUploadCSV()}
                setFile={setCSVFile}
                name="csv_transaksi_keluar"
                fileExtensions="csv"
              />
            </div>
          )}
          {/* {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleDeleteTrue()} handleIfFalse={(e) => handleDeleteFalse()} /></div>} */}
          <Toaster />
          <CardTableNoAdd
            tableTitle="Tabel Transaksi Pengeluaran"
            cols={transaksiKeluarTable(handleGetDetail, handleInsert)}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
            handleFilter={(e) => handleFilter()}
            handleResetFilter={(e) => handleResetFilter()}
            filterDataArr={filterDataArr}
            setDataFilter={setDataFilter}
            extraRow={extraTransaksiKeluarRow(totalRealisasi, totalTarget)}
            importCSVButton={true}
            handleUploadCSV={handleUploadCSV}
          />

          {dataExport.length > 0 && (
            <div className="py-2 px-4 hidden">
              <ExcelExport
                excelData={dataExport}
                fileName={"Transaksi_keluar"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
